module.exports = __webpack_public_path__ + "img/1019_pc.6240889b.gif";